<template>
  <div class="card noborder">
    <div class="card-header">
      <h5 class="mb-0">
        <button class="btn btn-link" type="button"
          @click="show = !show"
        >
          {{ header }}
        </button>
      </h5>
    </div>

    <div :id="id" class="collapse" :class="{show: show}" data-parent="#accordionShow">
      <div class="card-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['header'],
    data() {
      return {
        id: window._.uniqueId('step_'),
        show: true,
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/StepPart.vue